module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/hero@2x.10700a4.png";